
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, RouterOutlet } from '@angular/router';
import { TranslationService } from './common/services/languages/translation.service';
import { AuthenticationService } from '../app/authentication/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public translate: TranslationService,
    public authService: AuthenticationService,
    private readonly router: Router
  ) {
  }

  ngOnInit() {

    const urlParams = new URLSearchParams(window.location.search);
    const vin = urlParams.get('vin');
  
    if (vin) {
      sessionStorage.setItem('vinFromURL', vin);
      this.authService.setVinFromURL(vin);
    }
  
    this.translate.setLanguage = 'en';
    this.authService.initialize();
  
    this.authService.handleRedirect().subscribe({
      next: () => {
        // Initial dashboard navigation can be cancelled by guard before redirect handling completes.
        // Re-trigger route resolution once auth redirect is processed to avoid blank page at '/'.
        if (this.authService.isLoggedIn() && (this.router.url === '/' || this.router.url === '')) {
          this.router.navigateByUrl('/dashboard');
        }
      },
      error: () => undefined
    });
  }
}
